const doc = [({"zh_tw":({"adminConstantBookingPayTypeShort":({"creditCard":"信用卡", "onSite":"現場"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;